import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

const Home = () => import( /*webpackChunkName:"root/home"*/ '@/components/Home');
const Login = () => import( /*webpackChunkName:"root/login"*/ '@/components/Login');
const Welcome = () => import( /*webpackChunkName:"root/welcome"*/ '@/components/Welcome');

const Educational = () => import( /*webpackChunkName:"home/educational"*/ '@/components/pc/educational/index');
const Oj = () => import( /*webpackChunkName:"home/oj"*/ '@/components/oj/index');
// 官网管理页面
const Pc = () => import( /*webpackChunkName:"pc/index"*/ '@/components/pc/index');
const pc_Index = () => import( /*webpackChunkName:"pc/index"*/ '@/components/pc/pc_index/Index');
// 子
const Banner = () => import( /*webpackChunkName:"pc/index*/ '@/components/pc/pc_index/banner/Banner');
const Event = () => import( /*webpackChunkName:"pc/index"*/ '@/components/pc/pc_index/event/Event');


// 课程管理
const pc_Course = () => import( /*webpackChunkName:"pc/index"*/ '@/components/pc/pc_course/index');
// 子
const Plan = () => import( /*webpackChunkName:"pc/index"*/ '@/components/pc/pc_course/plan/Plan');
const Category = () => import( /*webpackChunkName:"pc/index"*/ '@/components/pc/pc_course/category/Category');
const Gif = () => import( /*webpackChunkName:"pc/index"*/ '@/components/pc/pc_course/gif/Gif');
const One = () =>
  import( /*webpackChunkName:"pc/index"*/ '@/components/pc/pc_course/category/categorys/Cat_one');
const Two = () =>
  import( /*webpackChunkName:"pc/index"*/ '@/components/pc/pc_course/category/categorys/Cat_two');

// 教务管理子
const Student = () => import( /*webpackChunkName:"home/educational/student"*/ '@/components/pc/educational/students/Students');
const Teacher = () => import( /*webpackChunkName:"home/educational/teacher"*/ '@/components/pc/educational/teachers/Teachers');

// oj管理
// oj_notice
const Notice = () => import( /*webpackChunkName:"oj_notice"*/ '@/components/oj/notice/Notice');
// oj_match
const Match = () => import( /*webpackChunkName:"oj_match"*/ '@/components/oj/match/index');
const online_Match = () => import( /*webpackChunkName:"oj_match"*/ '@/components/oj/match/matchs/online_match');
const offline_Match = () =>
  import( /*webpackChunkName:"oj_match"*/ '@/components/oj/match/matchs/offline_match');
const online_Test = () => import( /*webpackChunkName:"online_test"*/ '@/components/oj/match/test/online_test');
const offline_Test = () => import( /*webpackChunkName:"online_test"*/ '@/components/oj/match/test/offline_test');
// 权限管理
const Permiss = () => import( /*webpackChunkName:"permiss"*/ '@/components/oj/permissions/Permission');

// permiss子
const Users = () => import( /*webpackChunkName:"permiss"*/ '@/components/oj/permissions/perlist/Users');
const Limits = () => import( /*webpackChunkName:"permiss"*/ '@/components/oj/permissions/perlist/Limits');

// oj_fication
const Fication = () => import( /*webpackChunkName:"fication"*/ '@/components/oj/classification/Fication');
const Subject = () => import( /*webpackChunkName:"fication"*/ '@/components/oj/subject/index');
// oj_subject子页面
const Online = () =>
  import( /*webpackChunkName:"oj_subject"*/ '@/components/oj/subject/questions/Subject_online');
const Offline = () =>
  import( /*webpackChunkName:"oj_subject"*/ '@/components/oj/subject/questions/Subject_offline');
const TestData = () =>
  import( /*webpackChunkName:"oj_subject_testdata"*/ '@/components/oj/subject/testpoint/Testpoint');
const NOTF=()=>{
  import('@/components/404');
};

// oj题单管理
const quesList = () => import( /*webpackChunkName:"oj_quesList"*/ '@/components/oj/quesList/index');
const online_quesList = () => import( /*webpackChunkName:"oj_quesList"*/ '@/components/oj/quesList/quesLists/online_quesList');
const offline_quesList = () =>
  import( /*webpackChunkName:"oj_quesList"*/ '@/components/oj/quesList/quesLists/offline_quesList');

// 解决路由跳转错误的问题 似乎不起作用
// Error: Redirected when going from “/a“ to “/b“ via a navigation guard.
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};


Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.NODE_ENV === 'production' ? '/dist/' : '/', // 根据服务器根目录修改
  scrollBehavior: () => {     // 阻止页面回退
    history.pushState(null, null, document.URL);
  },
  mode: 'history',
  // mode:'hash',
  routes: [{
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/404',
    name: 'mester',
    component: NOTF
  },
  {
    path: '/home',
    name: '首页',
    component: Home,
    redirect: '/home/pc',
    children: [{
      path: '/welcome',
      name: '欢迎页面',
      component: Welcome
    },
    //     // 逐渐完善路由列表
    {
      path: '/home/pc',
      name: '官网管理',
      component: Pc,
      redirect: '/home/pc/index',
      children: [{
        path: '/home/pc/index',
        name: '官网首页',
        component: pc_Index,
        redirect: '/home/pc/index/banner',
        children: [{
          path: '/home/pc/index/banner',
          name: 'banner图管理',
          component: Banner
        },
        {
          path: '/home/pc/index/event',
          name: '赛事管理',
          component: Event
        }
        ]
      },
      {
        path: '/home/pc/course',
        name: '课程体系',
        component: pc_Course,
        redirect: '/home/pc/course/plans',
        children: [{
          path: '/home/pc/course/plans',
          name: '课件教案管理',
          component: Plan
        },
        {
          path: '/home/pc/course/gifs',
          name: 'Gif图管理',
          component: Gif
        },
        {
          path: '/home/pc/course/category',
          name: '类目管理',
          component: Category,
          redirect: '/home/pc/course/category/one',
          children: [{
            path: '/home/pc/course/category/one',
            name: '一级类目',
            component: One
          },
          {
            path: '/home/pc/course/category/two',
            name: '二级类目',
            component: Two
          }
          ]
        }
        ]
      },
      {
        path: '/home/pc/education',
        name: '教务管理',
        component: Educational,
        redirect: '/home/pc/education/teachers',
        children: [{
          path: '/home/pc/education/teachers',
          name: '教师管理',
          component: Teacher
        },
        {
          path: '/home/pc/education/students',
          name: '学员管理',
          component: Student
        }
        ]
      }

      ]
    },
    {
      path: '/home/oj',
      name: 'OJ管理',
      component: Oj,
      // redirect:"/home/oj/notice",
      children: [{
        path: '/home/oj/permissions',
        name: '权限管理',
        component: Permiss,
        redirect: '/home/oj/permissions/users',
        children: [{
          path: '/home/oj/permissions/users',
          name: '用户列表',
          component: Users
        },
        {
          path: '/home/oj/permissions/limits',
          name: '权限列表',
          component: Limits
        }
        ]
      },
      {
        path: '/home/oj/notice',
        name: '公告管理',
        component: Notice
      },
      {
        path: '/home/oj/subject',
        name: '题目管理',
        component: Subject,
        redirect: '/home/oj/subject/online_question',
        children: [{
          path: '/home/oj/subject/online_question',
          name: '上线题目',
          component: Online
        },
        {
          path: '/home/oj/subject/offline_question',
          name: '下线题目',
          component: Offline
        },
        {
          path: '/home/oj/subject/question_testdata',
          name: '编辑测试点',
          component: TestData
        }
        ]
      },
      {
        path: '/home/oj/fication',
        name: '标签管理',
        component: Fication
      },
      {
        path: '/home/oj/match',
        name: '竞赛管理',
        redirect: '/home/oj/match/online_match',
        component: Match,
        children: [{
          path: '/home/oj/match/online_match',
          name: '上线竞赛',
          component: online_Match
        },
        {
          path: '/home/oj/match/offline_match',
          name: '下线竞赛',
          component: offline_Match
        },
        {
          path: '/home/oj/match/online_test',
          name: '上线测验',
          component: online_Test
        },
        {
          path: '/home/oj/match/offline_test',
          name: '下线测验',
          component: offline_Test
        }
        ]
      },
      {
        path: '/home/oj/quesList',
        name: '题单管理',
        redirect: '/home/oj/quesList/online_quesList',
        component: quesList,
        children: [{
          path: '/home/oj/quesList/online_quesList',
          name: '上线题单',
          component: online_quesList
        },
        {
          path: '/home/oj/quesList/offline_quesList',
          name: '下线题单',
          component: offline_quesList
        },
        ]
      }
      ]
    }
    ]
  }
  ]
});

// 解决因为路由懒加载而无法加载组件的问题
router.onError((error) => {
  // 路由异步加载出现error：ChunkLoadError: Loading chunk about failed, 重新加载一次页面
  const pattern = /Loading chunk about failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  // 路由跳转 取消所有未得到回复的请求
  store.commit('clearToken');// 取消请求
  // 判断是否来自login页面
  if (to.path === '/login') {
    return next();
  }
  if(to.path==='/404'){
    return next();
  }
  const login = window.sessionStorage.getItem('Authorization');
  if (!login) {
    window.sessionStorage.removeItem('Authorization');
    window.sessionStorage.removeItem('activeItem');
    window.sessionStorage.removeItem('path');
    return next('/login');
  } else {
    return next();
  }
});

export default router;